import RequestBase from '../Resources/RequestBase';

export class IssueCardRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Cards';
        this.method = 'POST';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = { data: {} };
    }
}

export class ActivateCardRequest extends RequestBase {
    constructor(success) {
        super();
        this._url = '/Cards/Pans';
        this.method = 'PATCH';
        this.test = true;
        this.success = success;
        this.error = 'Wrong parameters';
        this.data = { data: {} };
    }
}



// WEBPACK FOOTER //
// ./src/TestResources/Cards.js